import Table from '@/components/Table';
import { notifications } from '@mantine/notifications';
import prepareTranslate from '@/helpers/dictionary';
import { Container } from '@mantine/core';
import {
  IconEye,
} from '@tabler/icons-react';
import PageTemplate from '@/components/PageTemplate';
import { useState } from 'react';
import { extractFilterOptions } from '@/components/Table/Table.functions';
import uploadedFilesMutations from '@/api/mutitations/uploadFile';
import docsMutation from '@/api/mutitations/docs';
import { downloadFile } from '@/helpers/download';
import s3Mutations from '@/api/mutitations/s3';

const Files = () => {
  const t = prepareTranslate();
  const [filterOptions, setFilterOptions] = useState({});
  const { mutateAsync: exportFileMutate } = docsMutation.useExportFile();
  const { mutateAsync: getFiles } = uploadedFilesMutations.useGetUploadedFiles();
  const { useDownload } = s3Mutations;
  const { mutateAsync: downloadMutate } = useDownload();

  // eslint-disable-next-line consistent-return
  const getData = async (start, end, query, sort) => {
    try {
      const getFilesDataObj = {
        start,
        end,
        query,
        sort,
      };

      const filesData = await getFiles(getFilesDataObj);
      const { data, count } = filesData;
      const newFilterOptions = extractFilterOptions(data, mockColumns);
      setFilterOptions(newFilterOptions);

      const returnedData = data.map((file) => ({
        ...file,
        product: file.product.map((item) => item.hebrew).join(', '),
      }));

      return {
        data: returnedData,
        count,
      };
    } catch (error) {
      notifications.show({
        title: t('pages.files.notification.errors.find.title'),
        message: t('pages.files.notification.errors.find.message'),
      });
      // eslint-disable-next-line no-console
      console.error('Error fetching files:', error);
    }
  };

  const handleClickOnView = async (id, row) => {
    const response = await downloadMutate({ path: row.path });
    const { file: fileData, contentType } = response;
    downloadFile(fileData, row.fileName, contentType);
    downloadFile(row.path);
  };

  // eslint-disable-next-line consistent-return
  const createFile = async (option, query) => {
    const requestColumns = mockColumns.filter((column) => column.title !== 'פעולות');
    const exportData = {
      query,
      fileType: option,
      service: 'agent',
      columns: requestColumns,
      titleArray: ['personalDetails.fullName'],
    };

    const fileTitleBase = t('pages.agents.fileTitle');
    const fileTitle = option === 'pdf' ? `${fileTitleBase}.pdf` : `${fileTitleBase}.xlsx`;

    try {
      const fileData = await exportFileMutate(exportData);
      return { fileData, fileTitle };
    } catch (error) {
      notifications.show({
        title: t('pages.agents.notification.errors.export.title'),
        message: t('pages.agents.notification.errors.export.message'),
      });
      // eslint-disable-next-line no-console
      console.error('Error fetching users:', error);
    }
  };

  const mockColumns = [
    {
      title: 'שם הקובץ',
      accessor: 'fileName',
      isVisible: true,
      sortable: true,
      isFilterActive: true,
    },
    {
      title: 'תאריך',
      accessor: 'date',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
      filterType: 'datePicker',
      transforms: [{
        func: 'date',
        params: {
          withTime: false,
        },
      }],
    },
    {
      title: 'חברה',
      accessor: 'companyId.hebrew',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'מוצר',
      accessor: 'product',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'פעולות',
      actions: [
        {
          title: 'צפייה',
          action: handleClickOnView,
          icon: <IconEye />,
          showLabel: true,
          isPrimary: true,
        },
      ],
    },
  ];

  const initialColumnFilters = mockColumns
    .filter((column) => column.accessor !== 'actions')
    .reduce((acc, column) => {
      acc[column.accessor] = '';
      return acc;
    }, {});

  const [columnFilters, setColumnFilters] = useState(initialColumnFilters);
  return (
    <>
      <PageTemplate
        title={t('pages.filesPage.title')}
        withBackButton={true}
      >

        <Container fluid>
          <Table
            columns={mockColumns}
            getData={getData}
            isColumnsActive={false}
            createFile={createFile}
            columnFilters={columnFilters}
            setColumnFilters={setColumnFilters}
            filterOptions={filterOptions}
            isExportActive={false}
          />
        </Container>
      </PageTemplate>
    </>
  );
};

export default Files;
